<template>
  <div class="daily-events">
    <dialog-sign ref="dialogSign"></dialog-sign>

    <dialog-tag ref="dialogTag"></dialog-tag>
  </div>
</template>

<script>
import storage from "@js/storage";
import app from "@js/app-node";
import DialogSign from "@components/sys/dialog-sign/index";
import DialogTag from "@components/sys/dialog-tags/index";
import { mapGetters, mapActions, mapMutations } from "vuex";
const NAME_SPACE = "daily_action",
  WHITE_LIST = ["unanswerd", "havesettag", "todaysignin"];

var date = (function () {
  var d = new Date();
  return `${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}`;
})();

var chain = new app.Chain();

function checkTodayActived(name) {
  var local = storage.getLocal(NAME_SPACE) || {},
    todays = local[date] || {};
  if (name) {
    if (todays[name]) {
      return true;
    }

    return false;
  }

  return Object.keys(todays).length === WHITE_LIST.length;
}

function updateTodayActive(name) {
  var local = storage.getLocal(NAME_SPACE) || {};
  local[date] = local[date] || {};
  local[date][name] = 1;

  storage.setLocal({
    [NAME_SPACE]: local,
  });
}

export default {
  components: {
    DialogSign,
    DialogTag,
  },
  computed: {
    ...mapGetters({
      userinfo: "userinfo/getData",
    }),
  },
  watch: {
    userinfo: {
      handler(e) {
        if (e && Object.keys(e).length) {
          this.checkUserStatus();
        }
      },
      deep: true,
    },
  },
  methods: {
    /**
     * 校验用户标签、签到、问答等信息
     */
    checkUserStatus() {
      const SERIAL_CODE = this.$cookies.get("SERIAL_CODE");
      if (!SERIAL_CODE) {
        //this.showSignDialogNotLogin();
        chain.run();

        return;
      }

      if (checkTodayActived()) {
        return;
      }

      this.$get(
        `${this.$store.state.api.webUrl}/usercenter/checkuserstatus.json`,
        (data) => {
          this.showSignDialog(data);
          this.showTagDialog(data);
          //没这个功能了不显示了--2024/8/13
          // this.showAnswerDialog(data);

          chain.run();
        }
      );
    },
    /**
     * 弹出未回答提示
     */
    showAnswerDialog(data) {
      if (data.unanswerd && !checkTodayActived("unanswerd")) {
        chain.link((next) => {
          showConfirm(
            `还有${data.unanswerdcount}道问题需要回答，马上去回答？`,
            "warning",
            () => {
              updateTodayActive("unanswerd");
              window.location.assign("/user/answer?tab=notAnswered");
              next();
            },
            () => {
              updateTodayActive("unanswerd");
              next();
            }
          );
        });
      }
    },
    showSignDialog(data) {
      if (!data.todaysignin && !checkTodayActived("todaysignin")) {
        chain.link((next) => {
          this.$refs.dialogSign.open({
            onclose: () => {
              next();
            },
          });
          updateTodayActive("todaysignin");
        });
      }
    },
    // 喜好设置
    showTagDialog(data) {
      return;
      if (!data.havesettag && !checkTodayActived("havesettag")) {
        chain.link((next) => {
          this.$refs.dialogTag.open({
            onclose: () => {
              updateTodayActive("havesettag");
              next();
            },
          });
        });
      }
    },
    //未登录或cookie为空时调用 没什么意义
    showSignDialogNotLogin() {
      return;
      if (!checkTodayActived("todaysigninnotlog")) {
        chain.link((next) => {
          this.$refs.dialogSign.open({
            onclose: () => {
              next();
            },
          });
          updateTodayActive("todaysigninnotlog");
        });
      }
    },
  },
  mounted() {
    this.checkUserStatus();
  },
};
</script>
